import { DndComponentsCtxt } from './DndComponentsContext';
import { DefaultReactDndConstructs, ReactDndCtxt } from './ReactDndContext';
import { jsx as _jsx } from "react/jsx-runtime";
function getDndModulesLoader(loadModulesPromises) {
  let result = null,
    error,
    loadPromise;
  return () => {
    if (!loadPromise) {
      loadPromise = Promise.all(loadModulesPromises());
    }
    loadPromise.then(modules => {
      result = [{
        Draggable: modules[0].Draggable,
        Droppable: modules[0].Droppable,
        DragDropContext: modules[0].DragDropContext
      }, {
        useDrag: modules[1].useDrag,
        useDragLayer: modules[1].useDragLayer,
        useDrop: modules[1].useDrop,
        getEmptyImage: modules[2].getEmptyImage
      }, {
        DndProvider: modules[1].DndProvider,
        HTML5Backend: modules[2].HTML5Backend
      }];
    }).catch(_error => error = _error);
    if (result) return result;else if (error) throw error;else throw loadPromise;
  };
}
const loadDndModules = getDndModulesLoader(() => [import('.'), import('react-dnd'), import('react-dnd-html5-backend')]);
export function DragAndDropProvider(props) {
  let rbdModules = null;
  let reactdndConstructs = DefaultReactDndConstructs;
  let HTML5Backend;
  let DndProvider;
  if (props.enableDragDrop) {
    const result = loadDndModules();
    [rbdModules, reactdndConstructs, {
      HTML5Backend,
      DndProvider
    }] = result;
  }
  return /*#__PURE__*/_jsx(DndComponentsCtxt.Provider, {
    value: rbdModules,
    children: /*#__PURE__*/_jsx(ReactDndCtxt.Provider, {
      value: reactdndConstructs,
      children: DndProvider && HTML5Backend ? /*#__PURE__*/_jsx(DndProvider, {
        backend: HTML5Backend,
        children: props.children
      }) : props.children
    })
  });
}
//# sourceMappingURL=DragAndDropProvider.js.map